import _ from 'lodash'

import { form, helper } from '@/utils'

export default {
  methods: {
    failedCallback (error) {
      this.saving = false

      helper.showErrorMessage(this, this.component, error)

      for (const key in this.data.file) {
        this.data.file[key].isLocal = false
      }
    },
    fieldType (type) {
      return type || 'text'
    },
    isColorPicker (type) {
      return this.fieldType(type) === 'colorpicker'
    },
    isNumber (type) {
      return this.fieldType(type) === 'number'
    },
    isPassword (type) {
      return this.fieldType(type) === 'password'
    },
    isText (type) {
      return this.fieldType(type) === 'text'
    },
    isTextarea (type) {
      return this.fieldType(type) === 'textarea'
    },
    onFileChange (id, e) {
      const fileList = e.target.files

      const invalid = _.some(fileList, file => !file.type.match('image'))
      if (invalid) e.target.value = ''

      const fileExist = !!(fileList && fileList[0])
      const currentFileName = fileExist && fileList[0].name ? fileList[0].name : ''
      const field = this.data.file[id]

      if (fileExist) {
        field.selectedFileName = currentFileName
        const reader = new FileReader()
        reader.onload = () => {
          field.currentImgSrc = reader.result
        }
        reader.readAsDataURL(fileList[0])
      }
    },
    removeImage (id) {
      this.data.file[id].currentImgSrc = null
      this.data.file[id].isLocal = true
      this.data.file[id].selectedFileName = ''
    },
    successCallback () {
      this.saving = false
      this.$message({
        message: this.$t('themeViewThemeSavedSuccessMessage'),
        showClose: true,
        type: 'success'
      })

      for (const key in this.data.file) {
        this.data.file[key].isLocal = !this.data.file[key].currentImgSrc
      }
    },
    submit (e) {
      return this.$validator.validateAll()
        .then((result) => {
          if (result) {
            this.data.text.hasOwnProperty('connection_user') ? this.updateEmailSettings(this.data.text) : this.updateTheme(e)
          }
        })
    },
    updateEmailSettings (textFields) {
      this.saving = true
      const data = Object.keys(textFields).reduce(
        (acc, curr) => {
          acc[curr] = textFields[curr].model
          return acc
        },
        {}
      )
      return this.$api.updateServiceConfig('email', data)
        .then(
          () => this.successCallback(),
          (e) => this.failedCallback(e)
        )
    },
    updateTheme (e) {
      this.saving = true
      const formData = form.getFormData(e)

      return this.$api.updateTheme(formData)
        .then(
          () => this.successCallback(),
          (e) => this.failedCallback(e)
        )
    },
    whenImageNotFound (id) {
      this.data.file[id].currentImgSrc = null
      this.data.file[id].isLocal = true
    }
  },
  name: 'ThemeView',
  props: {
    file: Object,
    loading: { default: true, type: Boolean },
    text: { type: Object, required: true },
    title: String
  },
  data () {
    return {
      component: 'themeView',
      data: {
        file: this.file,
        text: this.text
      },
      labelWidth: '200px',
      saving: false
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/ThemeView/ThemeView.js